var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signout text-center"},[_c('b-container',[_c('h1',[_vm._v("You have successfully signed out.")]),_c('router-link',{attrs:{"to":`/Auth`}},[_vm._v("Log In Again")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }